module.exports = __webpack_public_path__ + "img/sync_diagram.6364f80b.jpg";